// Mock data for homeschool tracking app

export const mockChildren = [
  {
    id: '1',
    name: 'Emma Johnson',
    grade: '5th Grade',
    age: 10,
    profileColor: '#3B82F6',
    subjects: ['Math', 'Science', 'English', 'History', 'Art']
  },
  {
    id: '2',
    name: 'Noah Johnson',
    grade: '3rd Grade',
    age: 8,
    profileColor: '#10B981',
    subjects: ['Math', 'Reading', 'Science', 'Social Studies']
  },
  {
    id: '3',
    name: 'Sophia Johnson',
    grade: 'Kindergarten',
    age: 5,
    profileColor: '#F59E0B',
    subjects: ['Letters', 'Numbers', 'Colors', 'Shapes']
  }
];

export const mockSubjects = [
  { id: '1', name: 'Math', color: '#3B82F6', icon: '📐' },
  { id: '2', name: 'Science', color: '#10B981', icon: '🔬' },
  { id: '3', name: 'English', color: '#8B5CF6', icon: '📚' },
  { id: '4', name: 'History', color: '#EF4444', icon: '🏛️' },
  { id: '5', name: 'Art', color: '#F59E0B', icon: '🎨' },
  { id: '6', name: 'Reading', color: '#EC4899', icon: '📖' },
  { id: '7', name: 'Social Studies', color: '#14B8A6', icon: '🌎' },
  { id: '8', name: 'Physical Education', color: '#F97316', icon: '⚽' }
];

export const mockLessonPlans = [
  {
    id: '1',
    childId: '1',
    subjectId: '1',
    title: 'Fractions and Decimals',
    description: 'Understanding fractions, decimals, and their relationships',
    startDate: '2025-08-18',
    endDate: '2025-08-22',
    status: 'in_progress',
    assignments: [
      {
        id: 'a1',
        title: 'Fractions Quiz',
        description: 'Quiz on adding and subtracting fractions',
        dateAssigned: '2025-08-18',
        dueDate: '2025-08-19',
        assignmentType: '2', // Quiz
        pointsPossible: 50,
        status: 'assigned'
      },
      {
        id: 'a2',
        title: 'Decimal Practice Worksheet',
        description: 'Complete problems 1-20 on decimal conversions',
        dateAssigned: '2025-08-19',
        dueDate: '2025-08-21',
        assignmentType: '3', // Homework
        pointsPossible: 20,
        status: 'assigned'
      }
    ]
  },
  {
    id: '2',
    childId: '1',
    subjectId: '2',
    title: 'Plant Life Cycle',
    description: 'Study of how plants grow and reproduce',
    startDate: '2025-08-20',
    endDate: '2025-08-27',
    status: 'in_progress',
    assignments: [
      {
        id: 'a3',
        title: 'Plant Observation Test',
        description: 'Test on plant parts and functions',
        dateAssigned: '2025-08-20',
        dueDate: '2025-08-22',
        assignmentType: '1', // Test
        pointsPossible: 100,
        status: 'assigned'
      }
    ]
  }
];

export const mockCompletedWork = [
  {
    id: '1',
    childId: '1',
    subjectId: '1',
    title: 'Multiplication Tables Quiz',
    description: 'Completed all times tables 1-12 with 95% accuracy',
    completedDate: '2025-08-15',
    pointsPossible: 50,
    pointsAwarded: 48,
    grade: 'A',
    assignmentType: '2', // Quiz
    notes: 'Excellent progress! Ready to move to division.',
    attachments: [
      { type: 'image', name: 'quiz_results.jpg', url: '/mock/image1.jpg' }
    ]
  },
  {
    id: '2',
    childId: '1',
    subjectId: '3',
    title: 'Book Report: Charlotte\'s Web',
    description: 'Comprehensive book report with character analysis',
    completedDate: '2025-08-14',
    pointsPossible: 100,
    pointsAwarded: 98,
    grade: 'A+',
    assignmentType: '3', // Homework
    notes: 'Beautiful writing and deep understanding of themes.',
    attachments: [
      { type: 'pdf', name: 'book_report.pdf', url: '/mock/doc1.pdf' },
      { type: 'image', name: 'drawing.jpg', url: '/mock/image2.jpg' }
    ]
  },
  {
    id: '3',
    childId: '2',
    subjectId: '6',
    title: 'Reading Log - Week 1',
    description: '30 minutes daily reading completed',
    completedDate: '2025-08-16',
    pointsPossible: 10,
    pointsAwarded: 10,
    grade: 'Complete',
    assignmentType: '4', // Classwork
    notes: 'Great enthusiasm for reading chapter books!',
    attachments: [
      { type: 'image', name: 'reading_log.jpg', url: '/mock/image3.jpg' }
    ]
  }
];

export const mockGoals = [
  {
    id: '1',
    childId: '1',
    title: 'Master Long Division',
    description: 'Complete long division problems with 3-digit divisors',
    targetDate: '2025-09-30',
    progress: 65,
    status: 'in_progress',
    milestones: [
      { id: '1', title: '2-digit divisors', completed: true },
      { id: '2', title: '3-digit divisors', completed: false }
    ]
  },
  {
    id: '2',
    childId: '1',
    title: 'Read 20 Chapter Books',
    description: 'Complete 20 age-appropriate chapter books this school year',
    targetDate: '2025-12-31',
    progress: 35,
    status: 'in_progress',
    milestones: [
      { id: '1', title: '5 books', completed: true },
      { id: '2', title: '10 books', completed: false },
      { id: '3', title: '15 books', completed: false },
      { id: '4', title: '20 books', completed: false }
    ]
  },
  {
    id: '3',
    childId: '2',
    title: 'Improve Handwriting',
    description: 'Practice cursive writing 15 minutes daily',
    targetDate: '2025-10-31',
    progress: 45,
    status: 'in_progress',
    milestones: [
      { id: '1', title: 'Lowercase letters', completed: true },
      { id: '2', title: 'Uppercase letters', completed: false }
    ]
  }
];

export const mockSchedule = [
  {
    id: '1',
    childId: '1',
    day: 'Monday',
    schedule: [
      { time: '9:00 AM', subject: 'Math', duration: '60 min' },
      { time: '10:15 AM', subject: 'English', duration: '45 min' },
      { time: '11:15 AM', subject: 'Science', duration: '60 min' },
      { time: '1:00 PM', subject: 'History', duration: '45 min' },
      { time: '2:00 PM', subject: 'Art', duration: '60 min' }
    ]
  }
];

export const mockUser = {
  id: 'user-1',
  email: 'parent@homeschool.com',
  name: 'Sarah Johnson',
  phone: '+1234567890',
  state: 'TX',
  grading_enabled: true,
  grading_scale: {
    'A': { min: 90, max: 100 },
    'B': { min: 80, max: 89 },
    'C': { min: 70, max: 79 },
    'D': { min: 60, max: 69 },
    'F': { min: 0, max: 59 }
  },
  show_grades_to_children: true,
  tokens_per_assignment: 1
};

// Child user logins (parent-managed)
export const mockChildLogins = [
  {
    id: '1',
    child_id: '1',
    username: 'emma',
    pin: '1234',
    tokens: 15,
    active: true,
    theme: 'purple' // purple/pink theme
  },
  {
    id: '2',
    child_id: '2',
    username: 'noah',
    pin: '5678',
    tokens: 8,
    active: true,
    theme: 'blue' // blue/green theme
  },
  {
    id: '3',
    child_id: '3',
    username: 'sophia',
    pin: '9012',
    tokens: 5,
    active: true,
    theme: 'purple' // purple/pink theme
  }
];

// Parent-created assignments
export const mockAssignments = [
  {
    id: '1',
    child_id: '1',
    subject_id: '1',
    title: 'Division Practice Worksheet',
    description: 'Complete pages 45-47 in your math workbook. Show all your work!',
    due_date: '2025-08-20',
    status: 'assigned', // assigned, submitted, graded
    tokens_reward: 2,
    created_date: '2025-08-16'
  },
  {
    id: '2',
    child_id: '1',
    subject_id: '3',
    title: 'Write a Story About Summer',
    description: 'Write a creative story (at least 2 paragraphs) about your favorite summer activity.',
    due_date: '2025-08-22',
    status: 'assigned',
    tokens_reward: 3,
    created_date: '2025-08-16'
  },
  {
    id: '3',
    child_id: '2',
    subject_id: '6',
    title: 'Read Chapter 5',
    description: 'Read chapter 5 and answer the questions at the end.',
    due_date: '2025-08-19',
    status: 'submitted',
    tokens_reward: 1,
    created_date: '2025-08-15',
    submitted_date: '2025-08-16'
  },
  {
    id: '4',
    child_id: '1',
    subject_id: '2',
    title: 'Science Experiment Report',
    description: 'Document your plant growth observations from this week.',
    due_date: '2025-08-25',
    status: 'graded',
    tokens_reward: 3,
    grade: 'A',
    created_date: '2025-08-10',
    submitted_date: '2025-08-14',
    graded_date: '2025-08-15'
  }
];

// Available rewards
export const mockRewards = [
  // Stickers (expanded to 12)
  { id: '1', name: 'Golden Star', type: 'sticker', cost: 5, icon: '⭐', description: 'A shiny golden star sticker!', image: '/rewards/star.png' },
  { id: '2', name: 'Rainbow Unicorn', type: 'sticker', cost: 8, icon: '🦄', description: 'Magical unicorn sticker', image: '/rewards/unicorn.png' },
  { id: '6', name: 'Achievement Badge', type: 'sticker', cost: 10, icon: '🏆', description: 'Trophy of excellence sticker', image: '/rewards/trophy.png' },
  { id: '8', name: 'Sparkle Heart', type: 'sticker', cost: 6, icon: '💖', description: 'A sparkling pink heart sticker!', image: '/rewards/heart.png' },
  { id: '9', name: 'Lightning Bolt', type: 'sticker', cost: 7, icon: '⚡', description: 'Electric energy sticker', image: '/rewards/lightning.png' },
  { id: '10', name: 'Fire Emoji', type: 'sticker', cost: 7, icon: '🔥', description: 'You\'re on fire sticker!', image: '/rewards/fire.png' },
  { id: '11', name: 'Party Popper', type: 'sticker', cost: 9, icon: '🎉', description: 'Celebrate your wins sticker!', image: '/rewards/party.png' },
  { id: '12', name: 'Cool Sunglasses', type: 'sticker', cost: 8, icon: '😎', description: 'Too cool for school sticker!', image: '/rewards/sunglasses.png' },
  { id: '13', name: 'Rocket Ship', type: 'sticker', cost: 10, icon: '🚀', description: 'Blast off to success sticker!', image: '/rewards/rocket.png' },
  { id: '14', name: 'Brain Power', type: 'sticker', cost: 11, icon: '🧠', description: 'Super smart sticker', image: '/rewards/brain.png' },
  { id: '15', name: 'Crown', type: 'sticker', cost: 12, icon: '👑', description: 'You\'re royalty sticker!', image: '/rewards/crown.png' },
  { id: '16', name: 'Diamond', type: 'sticker', cost: 15, icon: '💎', description: 'Rare and precious sticker!', image: '/rewards/diamond.png' },
  
  // Pets (expanded to 12 with detailed descriptions)
  { id: '3', name: 'Ember', type: 'pet', cost: 25, icon: '🐉', description: 'Meet Ember, your fiery dragon companion! This loyal dragon loves learning new tricks and breathes colorful sparkles instead of fire. Ember is brave, protective, and loves flying around your assignments. Feed it books to make it grow stronger!', image: '/rewards/dragon.png' },
  { id: '4', name: 'Buddy', type: 'pet', cost: 20, icon: '🐶', description: 'This is Buddy, the happiest golden retriever puppy ever! Buddy wags his tail every time you complete an assignment and loves to play fetch with your homework. He\'s always cheerful and makes learning more fun with his playful energy!', image: '/rewards/puppy.png' },
  { id: '5', name: 'Whiskers', type: 'pet', cost: 20, icon: '🐱', description: 'Say hello to Whiskers, a curious calico cat who loves to curl up next to you while you study. Whiskers is independent but affectionate, and purrs loudly when you earn good grades. She especially loves naps and helping you stay calm during tests!', image: '/rewards/cat.png' },
  { id: '7', name: 'Circuit', type: 'pet', cost: 30, icon: '🤖', description: 'Meet Circuit, your high-tech robot buddy! Circuit has LED eyes that change colors based on your progress and beeps happily when you learn something new. This robot companion is programmed to help organize your assignments and celebrates your achievements with cool light shows!', image: '/rewards/robot.png' },
  { id: '17', name: 'Hoppy', type: 'pet', cost: 18, icon: '🐰', description: 'This adorable bunny named Hoppy loves carrots and completing assignments! Hoppy hops with joy every time you finish your work and leaves little paw prints of encouragement. This energetic rabbit is always ready to cheer you on!', image: '/rewards/bunny.png' },
  { id: '18', name: 'Wisdom', type: 'pet', cost: 22, icon: '🦉', description: 'Wisdom is the smartest owl around! This nocturnal bird helps you with late-night study sessions and hoots encouragement when you solve difficult problems. Wisdom loves books almost as much as mice!', image: '/rewards/owl.png' },
  { id: '19', name: 'Waddles', type: 'pet', cost: 21, icon: '🐧', description: 'Waddles is the coolest penguin you\'ll ever meet! This tuxedo-wearing bird slides into your study sessions with fun facts about Antarctica. Waddles loves fish snacks and doing happy dances when you ace your assignments!', image: '/rewards/penguin.png' },
  { id: '20', name: 'Clever', type: 'pet', cost: 23, icon: '🦊', description: 'Clever is a cunning and quick-witted red fox! This clever fox friend loves solving puzzles with you and has a bushy tail that wags when you get answers right. Clever is playful, smart, and always ready for an adventure!', image: '/rewards/fox.png' },
  { id: '21', name: 'Bamboo', type: 'pet', cost: 28, icon: '🐼', description: 'Bamboo is a gentle and peaceful panda! This cuddly bear loves bamboo snacks and helps you stay calm during stressful study times. Bamboo does slow martial arts moves and teaches you the importance of balance and patience!', image: '/rewards/panda.png' },
  { id: '22', name: 'Splash', type: 'pet', cost: 26, icon: '🐬', description: 'Splash is a super smart and friendly dolphin! This aquatic companion makes learning feel like swimming through fun facts. Splash clicks and whistles happily when you complete ocean science assignments and loves doing flips!', image: '/rewards/dolphin.png' },
  { id: '23', name: 'Nibbles', type: 'pet', cost: 16, icon: '🐹', description: 'Nibbles is a tiny but mighty hamster! This adorable furball runs on a wheel that spins faster as you learn more. Nibbles loves storing knowledge in cheek pouches (metaphorically!) and squeaks with delight at your progress!', image: '/rewards/hamster.png' },
  { id: '24', name: 'Shelly', type: 'pet', cost: 19, icon: '🐢', description: 'Shelly is a wise turtle who teaches you that slow and steady wins the race! This ancient reptile has been around for ages and shares timeless study tips. Shelly\'s shell protects your confidence and reminds you that learning takes time!', image: '/rewards/turtle.png' }
];

// Child's earned rewards
export const mockEarnedRewards = [
  { id: '1', child_id: '1', reward_id: '1', earned_date: '2025-08-10' },
  { id: '2', child_id: '1', reward_id: '2', earned_date: '2025-08-12' },
  { id: '3', child_id: '1', reward_id: '4', earned_date: '2025-08-15' },
  { id: '4', child_id: '2', reward_id: '1', earned_date: '2025-08-14' }
];

// Pending work submissions (from children)
export const mockPendingWork = [
  {
    id: '1',
    child_id: '1',
    subject_id: '1',
    title: 'Division Worksheet',
    description: 'Completed all 20 division problems',
    submitted_date: '2025-08-16',
    status: 'pending',
    pointsPossible: 20,
    assignmentType: '3', // Homework
    attachments: [
      { type: 'image', name: 'worksheet.jpg', url: '/mock/worksheet1.jpg' }
    ]
  },
  {
    id: '2',
    child_id: '2',
    subject_id: '6',
    title: 'Chapter 3 Reading Log',
    description: 'Read and answered questions',
    submitted_date: '2025-08-16',
    status: 'pending',
    pointsPossible: 15,
    assignmentType: '4', // Classwork
    attachments: [
      { type: 'image', name: 'reading_log.jpg', url: '/mock/reading1.jpg' }
    ]
  }
];